import { QaScoreButton } from "./QaScoreButton";
import styles from "./QaScore.module.scss";

interface QaScoreResultBinaryProps {
  value: number;
  updateScore: (newScore: number) => Promise<void>;
  viewOnly?: boolean;
}

export function QaScoreResultBinary({
  value,
  updateScore,
  viewOnly = false,
}: QaScoreResultBinaryProps) {
  return (
    <div className={styles.QaScoreResult}>
      <QaScoreButton
        variant={"binary"}
        value={0}
        active={value === 0}
        updateScore={updateScore}
        label={"Not achieved"}
        viewOnly={viewOnly}
      />
      <QaScoreButton
        variant={"binary"}
        value={1}
        active={value === 1}
        updateScore={updateScore}
        label={"Achieved"}
        viewOnly={viewOnly}
      />
      <QaScoreButton
        variant={"binary"}
        value={-1}
        active={value === -1}
        updateScore={updateScore}
        label={"N/A"}
        viewOnly={viewOnly}
      />
    </div>
  );
}
